import styled from 'styled-components';
import { gray60, spacer4 } from '@spotify-internal/encore-foundation';
import IconChevronRight from "../Icon/IconChevronRight";
export default styled(IconChevronRight).attrs({
  iconSize: 16
}).withConfig({
  displayName: "Icon",
  componentId: "jwzsaf-0"
})(["color:", ";margin-left:", ";position:absolute;right:0;top:7px;"], gray60, spacer4);